export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Wan 2.6 视频生成器 - 新一代多模态AI视频创作平台',
        pageDescription:
            '体验Wan 2.6旗舰级多模态 AI 视频生成模型，不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。在WeryAI平台免费试用。',
        pageKeywords:
            'Wan 2.6, AI视频生成器,多模态 AI 视频生成模型,原生音视频同步, 电影级 1080p 分辨率, 智能分镜功能, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Wan 2.6 旗舰级多模态 AI 视频生成模型',
        short_title: '多模态AI视频模型',
        generatorDescription:
            'WeryAI 现已深度集成Wan 2.6模型，Wan 2.6 是阿里云通义万相（Wanx）团队最新发布的旗舰级多模态 AI 视频生成模型。作为 Wan 系列的重大升级版本，它不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。Wan 2.6 专为解决长视频叙事难题而生，其独有的智能分镜功能支持长达 15 秒的连贯多镜头创作，是创作者实现“从剧本到成片”的终极工具。快来 WeryAI 免费体验 Wan 2.6，感受“有声有色”的 AI 创作新纪元！',
        generatorDescriptionHighlight1:
            'Wan 2.6 模型现已集成到 WeryAI 视频生成器中，可生成逼真的视频',
        generatorDescriptionText2: '。点击此处',
        generatorDescriptionHighlight2: '免费试用 Wan 2.6',
        generatorDescriptionEnd: '！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 核心功能特性',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '原生音视频同步生成',
        nativeAudioIntegrationDescription:
            'Wan 2.6 打破了视觉与听觉的界限，在生成视频画面的同时，能够根据内容自动生成精准同步的音效（如脚步声、雨声）甚至角色对白口型，无需后期配音即可获得完整的视听素材。',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '智能多镜头叙事',
        enhancedDynamicEffectsDescription:
            '模型具备极强的语义理解能力，能自动将一段复杂的长提示词拆解为多个分镜（如全景接特写），并确保角色形象、场景光影在不同镜头间保持高度一致，单次生成即可讲述一个完整的小故事。',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '角色表演复刻',
        preciseCameraControlDescription:
            '通过“视频生视频”功能，用户可以上传一段真人表演视频作为参考，Wan 2.6 能将原视频中的动作幅度、面部表情甚至运镜节奏，精准迁移到新生成的虚拟角色（如动漫人物或3D模型）身上，实现“AI 动作捕捉”。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '15 秒长视频连贯生成',
        enhancedVisualRealismDescription:
            '支持生成长达 15 秒的 1080p/24fps 高清视频，相比传统模型的短片段，Wan 2.6 提供了更充裕的时间来展现复杂的动作逻辑和环境变化，且全程保持画质无崩坏。',

        // 如何使用部分
        howToUseTitle: '如何在 WeryAI 上使用 Wan 2.6',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Wan 2.6 模型',
        step2Title: '输入内容',
        step2Description:
            '在文本框中描述您想要的画面，或上传参考图片/视频以启用“图生视频”或“角色复刻”功能。',
        step3Title: '生成视频',
        step3Description:
            '设置参数（如 16:9 比例、15秒时长），点击“生成”按钮，稍等片刻即可预览并下载您的有声大片。',

        // YouTube 视频部分
        youtubeTitle: '关于 Wan 2.6 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Wan 2.6 AI 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        sora2Title: 'OpenAI Sora-2 AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.6，将您的创意转化为精彩视频',
        ctaButton: '立即体验 Wan 2.6',
        ctaDisclaimer: '无须信用卡，注册即可使用',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Generator - Next-Gen Multimodal AI Video Creation Platform',
        pageDescription:
            'Try Wan 2.6, a flagship multimodal AI video generation model. It delivers cinematic 1080p video and a breakthrough in Native Audio-Visual Sync—generating visuals together with matching sound effects and voices in one go. Free to try on WeryAI.',
        pageKeywords:
            'Wan 2.6, AI video generator, multimodal AI video model, native audio-visual sync, cinematic 1080p, intelligent storyboarding, free AI video, WeryAI, video creation',

        // 生成器部分
        generatorTitle: 'Wan 2.6 Flagship Multimodal AI Video Generation Model',
        short_title: 'Multimodal AI Video Model',
        generatorDescription:
            'WeryAI now deeply integrates the Wan 2.6 model, Wan 2.6 is the latest flagship multimodal AI video generation model released by Alibaba Cloud’s Tongyi Wanxiang (Wanx) team. As a major upgrade in the Wan series, it not only supports cinematic 1080p output but also achieves a breakthrough in Native Audio-Visual Sync—generating visuals along with matched sound effects and voices in a single pass. Built to tackle long-form storytelling, Wan 2.6 features intelligent multi-shot storyboarding that enables up to 15 seconds of coherent, multi-camera creation, helping creators go from script to final cut. Try Wan 2.6 for free on WeryAI and step into a new era of “video with sound, made by AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 is now integrated into the WeryAI video generator to create realistic videos',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'try Wan 2.6 for free',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 Key Features',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native Audio-Visual Sync Generation',
        nativeAudioIntegrationDescription:
            'Wan 2.6 breaks the boundary between sight and sound—while generating the video, it can automatically create precisely synchronized audio (e.g., footsteps, rain) and even character dialogue lip-sync, delivering complete audiovisual assets without post-dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent Multi-Shot Storytelling',
        enhancedDynamicEffectsDescription:
            'With strong semantic understanding, the model can decompose a complex long prompt into multiple shots (e.g., wide to close-up) and keep character identity, scenes, and lighting highly consistent across shots—telling a complete mini story in a single generation.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance & Motion Re-enactment',
        preciseCameraControlDescription:
            'Using “video-to-video”, you can upload a real performance clip as reference. Wan 2.6 can accurately transfer the motion range, facial expressions, and even camera rhythm to a newly generated virtual character (e.g., anime or 3D), enabling “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Coherent 15-Second Long Video Generation',
        enhancedVisualRealismDescription:
            'Generate up to 15 seconds of 1080p/24fps HD video. Compared with short clips from traditional models, Wan 2.6 gives more time to portray complex actions and environmental changes while maintaining stable, high-quality visuals throughout.',

        // 如何使用部分
        howToUseTitle: 'How to Use Wan 2.6 on WeryAI',
        step1Title: 'Choose a Model',
        step1Description: 'Select the Wan 2.6 model in the AI Video tool',
        step2Title: 'Enter Your Content',
        step2Description:
            'Describe the scene you want in the text box, or upload a reference image/video to enable “Image to Video” or “Performance & Motion Re-enactment”.',
        step3Title: 'Generate the Video',
        step3Description:
            'Set parameters (e.g., 16:9 aspect ratio, 15-second duration), click “Generate”, then wait a moment to preview and download your video with sound.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube Videos About the Wan 2.6 Video Model',

        // X Posts 部分
        xPostsTitle: 'Trending X Posts About the Wan 2.6 AI Video Model',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Frequently Asked Questions',

        // CTA 部分
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Try Wan 2.6 now and turn your ideas into amazing videos',
        ctaButton: 'Try Wan 2.6 Now',
        ctaDisclaimer: 'No credit card required — sign up to start',

        // 视频播放相关
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadingError: 'Failed to load video',
        videoReload: 'Reload',
    },
    ja: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 動画生成 - 次世代マルチモーダルAI動画制作プラットフォーム',
        pageDescription:
            'Wan 2.6 のフラッグシップ級マルチモーダル AI 動画生成モデルを体験。映画品質の 1080p に対応し、Native Audio-Visual Sync（音声・映像のネイティブ同期）により、映像と一致する効果音や音声を同時に生成できます。WeryAI で無料体験。',
        pageKeywords:
            'Wan 2.6, AI動画生成, マルチモーダルAI動画モデル, ネイティブ音声・映像同期, 映画品質1080p, ストーリーボード, 無料AI動画, WeryAI, 動画制作',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 フラッグシップ級マルチモーダル AI 動画生成モデル',
        short_title: 'マルチモーダルAI動画モデル',
        generatorDescription:
            'WeryAI はWan 2.6モデルを深く統合し、Wan 2.6 は、Alibaba Cloud の通義万相（Wanx）チームが最新リリースしたフラッグシップ級マルチモーダル AI 動画生成モデルです。Wan シリーズの大幅アップグレードとして、映画品質の 1080p 出力に対応するだけでなく、Native Audio-Visual Sync（音声・映像のネイティブ同期）という大きな突破を実現し、映像と一致する効果音や音声を一括生成できます。長尺ストーリーテリングの課題解決を目的に設計され、最大 15 秒の一貫したマルチショット生成を可能にする「インテリジェント分鏡」機能を搭載。“脚本から完成映像へ”を最短距離で実現する究極ツールです。WeryAI で Wan 2.6 を無料で体験し、「音も映像も」AI で創る新時代を体感してください。',
        generatorDescriptionHighlight1:
            'Wan 2.6 は WeryAI の動画生成器に統合され、リアルな動画を生成できます',
        generatorDescriptionText2: '。こちらをクリックして',
        generatorDescriptionHighlight2: 'Wan 2.6 を無料で試す',
        generatorDescriptionEnd: '！',

        // 标签页
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 の主要機能',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'ネイティブ音声・映像同期生成',
        nativeAudioIntegrationDescription:
            'Wan 2.6 は視覚と聴覚の境界を打ち破り、映像生成と同時に、内容に合わせた高精度な同期音（足音・雨音など）や、キャラクターの口パクに合う台詞音声まで自動生成。後付けの吹き替えなしで、完成度の高い視聴覚素材を得られます。',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'インテリジェントなマルチショット物語生成',
        enhancedDynamicEffectsDescription:
            '強力な意味理解により、複雑で長いプロンプトを複数のショット（例：ワイド→クローズアップ）に自動分解し、キャラクターやシーンの光・影を高い一貫性で維持。1 回の生成で小さな物語を完結させられます。',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '演技・動きの再現',
        preciseCameraControlDescription:
            '「動画から動画（video-to-video）」で実写の演技動画を参照としてアップロードすると、Wan 2.6 は動きの振れ幅や表情、さらにはカメラワークのリズムまでを、新しく生成する仮想キャラクター（アニメや 3D など）に高精度で移植し、“AI モーションキャプチャ”を実現します。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '最長 15 秒の一貫した長尺生成',
        enhancedVisualRealismDescription:
            '最大 15 秒の 1080p/24fps 高精細動画を生成可能。従来モデルの短尺クリップと比べ、複雑な動作や環境変化を表現する余裕が増え、全編を通して画質の破綻を抑えながら安定したクオリティを維持します。',

        // 如何使用部分
        howToUseTitle: 'WeryAI で Wan 2.6 を使う方法',
        step1Title: 'モデルを選択',
        step1Description: 'AI 動画ツールで Wan 2.6 モデルを選択します',
        step2Title: '内容を入力',
        step2Description:
            'テキスト欄に作りたい映像を説明するか、参照画像/動画をアップロードして「画像から動画」または「演技・動きの再現」を有効にします。',
        step3Title: '動画を生成',
        step3Description:
            'パラメータ（例：16:9 比率、15 秒）を設定し、「生成」をクリック。少し待つだけでプレビューとダウンロードができます。',

        // YouTube 视频部分
        youtubeTitle: 'Wan 2.6 動画モデルに関する YouTube 動画',

        // X Posts 部分
        xPostsTitle: 'Wan 2.6 AI 動画モデルに関する人気の X 投稿',

        // 探索其他模型部分
        exploreModelsTitle: '他のモデルを探す',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 動画生成',
        sora2Title: 'OpenAI Sora-2 AI 動画生成',

        // FAQ 部分
        faqTitle: 'よくある質問',

        // CTA 部分
        ctaTitle: '制作を始めますか？',
        ctaDescription:
            '今すぐ Wan 2.6 を体験して、アイデアを素敵な動画に変えましょう',
        ctaButton: 'Wan 2.6 を今すぐ体験',
        ctaDisclaimer: 'クレジットカード不要、登録だけですぐ利用可能',

        // 视频播放相关
        videoNotSupported: 'お使いのブラウザは動画再生に対応していません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 비디오 생성기 - 차세대 멀티모달 AI 영상 제작 플랫폼',
        pageDescription:
            '플래그십 멀티모달 AI 비디오 생성 모델 Wan 2.6을 경험해 보세요. 영화급 1080p 해상도는 물론 Native Audio-Visual Sync(원생 오디오-비주얼 동기화)로 영상과 어울리는 효과음·음성까지 한 번에 생성합니다. WeryAI에서 무료로 사용해 보세요.',
        pageKeywords:
            'Wan 2.6, AI 비디오 생성기, 멀티모달 AI 비디오 모델, 원생 오디오-비주얼 동기화, 영화급 1080p, 스마트 스토리보드, 무료 AI 영상, WeryAI, 영상 제작',

        // 生成器部分
        generatorTitle: 'Wan 2.6 플래그십 멀티모달 AI 비디오 생성 모델',
        short_title: '멀티모달 AI 비디오 모델',
        generatorDescription:
            'WeryAI는 이제 Wan 2.6 모델을 심층 통합하여, Wan 2.6은 Alibaba Cloud 통의만상(Tongyi Wanxiang, Wanx) 팀이 최신 공개한 플래그십 멀티모달 AI 비디오 생성 모델입니다. Wan 시리즈의 대형 업그레이드로, 영화급 1080p 출력뿐 아니라 Native Audio-Visual Sync(원생 오디오-비주얼 동기화)라는 돌파를 통해 영상과 매칭되는 효과음·음성을 한 번에 생성할 수 있습니다. 장편 스토리텔링의 난제를 해결하기 위해 설계되었으며, 최대 15초까지 이어지는 다중 샷(멀티 카메라) 생성이 가능한 ‘스마트 분할 컷(스토리보드)’ 기능으로 “대본에서 완성본까지”를 빠르게 돕습니다. WeryAI에서 Wan 2.6을 무료로 체험하고, ‘소리와 화면이 함께’ 만들어지는 AI 창작의 새 시대를 만나보세요.',
        generatorDescriptionHighlight1:
            'Wan 2.6 모델이 WeryAI 비디오 생성기에 통합되어 사실적인 영상을 만들 수 있습니다',
        generatorDescriptionText2: '. 여기를 클릭하여',
        generatorDescriptionHighlight2: 'Wan 2.6 무료 체험',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: '이미지 → 비디오',
        tabTextToVideo: '텍스트 → 비디오',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 핵심 기능',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '원생 오디오-비주얼 동기화 생성',
        nativeAudioIntegrationDescription:
            'Wan 2.6은 시각과 청각의 경계를 허물어, 영상 생성과 동시에 콘텐츠에 맞춘 정밀 동기화 음향(예: 발소리, 빗소리)과 캐릭터 대사 립싱크까지 자동으로 생성합니다. 후반 더빙 없이도 완성도 높은 시청각 소재를 얻을 수 있습니다.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '지능형 멀티샷 스토리텔링',
        enhancedDynamicEffectsDescription:
            '강력한 의미 이해 능력으로 복잡한 장문 프롬프트를 여러 컷(예: 와이드 → 클로즈업)으로 자동 분해하고, 컷 간 캐릭터·장면·조명 일관성을 높게 유지해 한 번의 생성으로 작은 이야기를 완성할 수 있습니다.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '연기/모션 재현',
        preciseCameraControlDescription:
            '“비디오 → 비디오” 기능으로 실제 연기 영상을 레퍼런스로 업로드하면, Wan 2.6이 동작 범위·표정·카메라 워크 리듬까지 새로 생성되는 가상 캐릭터(애니메이션/3D 등)에 정밀하게 옮겨 ‘AI 모션 캡처’를 구현합니다.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '최대 15초 장면 일관 생성',
        enhancedVisualRealismDescription:
            '최대 15초의 1080p/24fps 고화질 영상을 생성합니다. 기존 모델의 짧은 클립 대비, 복잡한 동작과 환경 변화를 표현할 시간이 더 넉넉하며, 전 구간에서 안정적인 화질을 유지합니다.',

        // 如何使用部分
        howToUseTitle: 'WeryAI에서 Wan 2.6 사용하는 방법',
        step1Title: '모델 선택',
        step1Description: 'AI 비디오 도구에서 Wan 2.6 모델을 선택하세요',
        step2Title: '내용 입력',
        step2Description:
            '텍스트 박스에 원하는 장면을 설명하거나, 참고 이미지/영상을 업로드해 “이미지 → 비디오” 또는 “연기/모션 재현” 기능을 사용하세요.',
        step3Title: '비디오 생성',
        step3Description:
            '파라미터(예: 16:9 비율, 15초 길이)를 설정한 뒤 “생성”을 클릭하면 잠시 후 미리보기 및 다운로드가 가능합니다.',

        // YouTube 视频部分
        youtubeTitle: 'Wan 2.6 비디오 모델 관련 YouTube 영상',

        // X Posts 部分
        xPostsTitle: 'Wan 2.6 AI 비디오 모델 인기 X 게시물',

        // 探索其他模型部分
        exploreModelsTitle: '다른 모델 둘러보기',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',

        // FAQ 部分
        faqTitle: '자주 묻는 질문',

        // CTA 部分
        ctaTitle: '창작을 시작할 준비가 되셨나요?',
        ctaDescription:
            '지금 Wan 2.6을 체험하고 아이디어를 멋진 영상으로 바꿔보세요',
        ctaButton: 'Wan 2.6 지금 체험하기',
        ctaDisclaimer: '신용카드 불필요, 가입만 하면 바로 사용 가능',

        // 视频播放相关
        videoNotSupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Wan 2.6 视频生成器 - 新一代多模态AI视频创作平台',
        pageDescription:
            '体验Wan 2.6旗舰级多模态 AI 视频生成模型，不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。在WeryAI平台免费试用。',
        pageKeywords:
            'Wan 2.6, AI视频生成器,多模态 AI 视频生成模型,原生音视频同步, 电影级 1080p 分辨率, 智能分镜功能, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Wan 2.6 旗舰级多模态 AI 视频生成模型',
        short_title: '多模态AI视频模型',
        generatorDescription:
            'WeryAI 現已深度整合Wan 2.6模型，Wan 2.6 是阿里云通义万相（Wanx）团队最新发布的旗舰级多模态 AI 视频生成模型。作为 Wan 系列的重大升级版本，它不仅支持生成电影级 1080p 分辨率的视频，更实现了 原生音视频同步（Native Audio-Visual Sync）的突破，能够一次性生成画面与匹配的音效、人声。Wan 2.6 专为解决长视频叙事难题而生，其独有的智能分镜功能支持长达 15 秒的连贯多镜头创作，是创作者实现“从剧本到成片”的终极工具。快来 WeryAI 免费体验 Wan 2.6，感受“有声有色”的 AI 创作新纪元！',
        generatorDescriptionHighlight1:
            'Wan 2.6 模型现已集成到 WeryAI 视频生成器中，可生成逼真的视频',
        generatorDescriptionText2: '。点击此处',
        generatorDescriptionHighlight2: '免费试用 Wan 2.6',
        generatorDescriptionEnd: '！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 核心功能特性',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: '原生音视频同步生成',
        nativeAudioIntegrationDescription:
            'Wan 2.6 打破了视觉与听觉的界限，在生成视频画面的同时，能够根据内容自动生成精准同步的音效（如脚步声、雨声）甚至角色对白口型，无需后期配音即可获得完整的视听素材。',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: '智能多镜头叙事',
        enhancedDynamicEffectsDescription:
            '模型具备极强的语义理解能力，能自动将一段复杂的长提示词拆解为多个分镜（如全景接特写），并确保角色形象、场景光影在不同镜头间保持高度一致，单次生成即可讲述一个完整的小故事。',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: '角色表演复刻',
        preciseCameraControlDescription:
            '通过“视频生视频”功能，用户可以上传一段真人表演视频作为参考，Wan 2.6 能将原视频中的动作幅度、面部表情甚至运镜节奏，精准迁移到新生成的虚拟角色（如动漫人物或3D模型）身上，实现“AI 动作捕捉”。',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: '15 秒长视频连贯生成',
        enhancedVisualRealismDescription:
            '支持生成长达 15 秒的 1080p/24fps 高清视频，相比传统模型的短片段，Wan 2.6 提供了更充裕的时间来展现复杂的动作逻辑和环境变化，且全程保持画质无崩坏。',

        // 如何使用部分
        howToUseTitle: '如何在 WeryAI 上使用 Wan 2.6',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Wan 2.6 模型',
        step2Title: '输入内容',
        step2Description:
            '在文本框中描述您想要的画面，或上传参考图片/视频以启用“图生视频”或“角色复刻”功能。',
        step3Title: '生成视频',
        step3Description:
            '设置参数（如 16:9 比例、15秒时长），点击“生成”按钮，稍等片刻即可预览并下载您的有声大片。',

        // YouTube 视频部分
        youtubeTitle: '关于 Wan 2.6 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Wan 2.6 AI 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        sora2Title: 'OpenAI Sora-2 AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.6，将您的创意转化为精彩视频',
        ctaButton: '立即体验 Wan 2.6',
        ctaDisclaimer: '无须信用卡，注册即可使用',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Generator - Next-Gen Multimodal AI Video Creation Platform',
        pageDescription:
            'Try Wan 2.6, a flagship multimodal AI video generation model. It delivers cinematic 1080p video and a breakthrough in Native Audio-Visual Sync—generating visuals together with matching sound effects and voices in one go. Free to try on WeryAI.',
        pageKeywords:
            'Wan 2.6, AI video generator, multimodal AI video model, native audio-visual sync, cinematic 1080p, intelligent storyboarding, free AI video, WeryAI, video creation',

        // 生成器部分
        generatorTitle: 'Wan 2.6 Flagship Multimodal AI Video Generation Model',
        short_title: 'Multimodal AI Video Model',
        generatorDescription:
            'WeryAI jest teraz głęboko zintegrowane z modelem Wan 2.6, Wan 2.6 is the latest flagship multimodal AI video generation model released by Alibaba Cloud’s Tongyi Wanxiang (Wanx) team. As a major upgrade in the Wan series, it not only supports cinematic 1080p output but also achieves a breakthrough in Native Audio-Visual Sync—generating visuals along with matched sound effects and voices in a single pass. Built to tackle long-form storytelling, Wan 2.6 features intelligent multi-shot storyboarding that enables up to 15 seconds of coherent, multi-camera creation, helping creators go from script to final cut. Try Wan 2.6 for free on WeryAI and step into a new era of “video with sound, made by AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 is now integrated into the WeryAI video generator to create realistic videos',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'try Wan 2.6 for free',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 Key Features',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native Audio-Visual Sync Generation',
        nativeAudioIntegrationDescription:
            'Wan 2.6 breaks the boundary between sight and sound—while generating the video, it can automatically create precisely synchronized audio (e.g., footsteps, rain) and even character dialogue lip-sync, delivering complete audiovisual assets without post-dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent Multi-Shot Storytelling',
        enhancedDynamicEffectsDescription:
            'With strong semantic understanding, the model can decompose a complex long prompt into multiple shots (e.g., wide to close-up) and keep character identity, scenes, and lighting highly consistent across shots—telling a complete mini story in a single generation.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance & Motion Re-enactment',
        preciseCameraControlDescription:
            'Using “video-to-video”, you can upload a real performance clip as reference. Wan 2.6 can accurately transfer the motion range, facial expressions, and even camera rhythm to a newly generated virtual character (e.g., anime or 3D), enabling “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Coherent 15-Second Long Video Generation',
        enhancedVisualRealismDescription:
            'Generate up to 15 seconds of 1080p/24fps HD video. Compared with short clips from traditional models, Wan 2.6 gives more time to portray complex actions and environmental changes while maintaining stable, high-quality visuals throughout.',

        // 如何使用部分
        howToUseTitle: 'How to Use Wan 2.6 on WeryAI',
        step1Title: 'Choose a Model',
        step1Description: 'Select the Wan 2.6 model in the AI Video tool',
        step2Title: 'Enter Your Content',
        step2Description:
            'Describe the scene you want in the text box, or upload a reference image/video to enable “Image to Video” or “Performance & Motion Re-enactment”.',
        step3Title: 'Generate the Video',
        step3Description:
            'Set parameters (e.g., 16:9 aspect ratio, 15-second duration), click “Generate”, then wait a moment to preview and download your video with sound.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube Videos About the Wan 2.6 Video Model',

        // X Posts 部分
        xPostsTitle: 'Trending X Posts About the Wan 2.6 AI Video Model',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Frequently Asked Questions',

        // CTA 部分
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Try Wan 2.6 now and turn your ideas into amazing videos',
        ctaButton: 'Try Wan 2.6 Now',

        ctaDisclaimer: 'No credit card required — sign up to start',


        // 视频播放相关
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadingError: 'Failed to load video',
        videoReload: 'Reload',
    },
    es: {
        // 页面标题和描述
        pageTitle:
            'Generador de video Wan 2.6 - Plataforma de creación de video con IA multimodal de nueva generación',
        pageDescription:
            'Descubre Wan 2.6, el modelo multimodal insignia de generación de video con IA. Ofrece video 1080p con calidad cinematográfica y un avance en Native Audio-Visual Sync: genera imagen y sonido (efectos y voz) sincronizados en una sola pasada. Pruébalo gratis en WeryAI.',
        pageKeywords:
            'Wan 2.6, generador de video con IA, modelo de video IA multimodal, sincronización nativa audio-visual, 1080p cinematográfico, guion gráfico inteligente, video IA gratis, WeryAI, creación de video',

        // 生成器部分
        generatorTitle:
            'Wan 2.6: modelo insignia multimodal de generación de video con IA',
        short_title: 'Modelo de video de IA multimodal',
        generatorDescription:
            'WeryAI ahora integra profundamente el modelo Wan 2.6, Wan 2.6 es el modelo multimodal insignia más reciente publicado por el equipo de Tongyi Wanxiang (Wanx) de Alibaba Cloud. Como una gran actualización de la serie Wan, no solo admite salida 1080p con calidad cinematográfica, sino que también logra un avance en Native Audio-Visual Sync: genera el video junto con efectos de sonido y voces que encajan en una sola ejecución. Diseñado para resolver el desafío de la narrativa en videos largos, Wan 2.6 incluye un sistema de guion gráfico inteligente de múltiples tomas que permite hasta 15 segundos de creación coherente con varios planos, ayudando a los creadores a pasar “del guion al corte final”. Pruébalo gratis en WeryAI y vive una nueva era de creación con IA, con imagen y sonido.',
        generatorDescriptionHighlight1:
            'Wan 2.6 ya está integrado en el generador de video de WeryAI para crear videos realistas',
        generatorDescriptionText2: '. Haz clic aquí para',
        generatorDescriptionHighlight2: 'probar Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Imagen a video',
        tabTextToVideo: 'Texto a video',

        // 核心功能部分
        coreFeaturesTitle: 'Funciones clave de Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Generación con sincronización nativa audio‑visual',
        nativeAudioIntegrationDescription:
            'Wan 2.6 rompe la barrera entre lo visual y lo auditivo: mientras genera el video, puede crear automáticamente audio sincronizado con precisión (p. ej., pasos, lluvia) e incluso diálogo con lip‑sync, entregando recursos audiovisuales completos sin doblaje posterior.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Narrativa inteligente de múltiples tomas',
        enhancedDynamicEffectsDescription:
            'Con una gran comprensión semántica, el modelo puede descomponer un prompt largo y complejo en varias tomas (p. ej., plano general a primer plano) y mantener alta consistencia de personajes, escena e iluminación entre tomas, contando una historia completa en una sola generación.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Recreación de actuación y movimiento',
        preciseCameraControlDescription:
            'Con “video a video”, puedes subir un clip de actuación real como referencia. Wan 2.6 puede transferir con precisión el rango de movimiento, expresiones faciales e incluso el ritmo de cámara a un personaje virtual recién generado (p. ej., anime o 3D), logrando “captura de movimiento con IA”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Generación coherente de video largo de 15 segundos',
        enhancedVisualRealismDescription:
            'Genera hasta 15 segundos de video HD 1080p/24fps. Frente a los clips cortos de modelos tradicionales, Wan 2.6 ofrece más tiempo para mostrar acciones complejas y cambios del entorno, manteniendo una calidad estable de principio a fin.',

        // 如何使用部分
        howToUseTitle: 'Cómo usar Wan 2.6 en WeryAI',
        step1Title: 'Elige el modelo',
        step1Description:
            'Selecciona el modelo Wan 2.6 en la herramienta de video con IA',
        step2Title: 'Introduce el contenido',
        step2Description:
            'Describe la escena en el cuadro de texto o sube una imagen/video de referencia para activar “Imagen a video” o “Recreación de actuación y movimiento”.',
        step3Title: 'Genera el video',
        step3Description:
            'Configura parámetros (p. ej., relación 16:9 y duración de 15 s), haz clic en “Generar” y en unos momentos podrás previsualizar y descargar tu video con sonido.',

        // YouTube 视频部分
        youtubeTitle: 'Videos de YouTube sobre el modelo de video Wan 2.6',

        // X Posts 部分
        xPostsTitle:
            'Publicaciones populares en X sobre el modelo de video con IA Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Explora otros modelos',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Generador de video con IA Google Veo 3.1',
        sora2Title: 'Generador de video con IA OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Preguntas frecuentes',

        // CTA 部分
        ctaTitle: '¿Listo para empezar a crear?',
        ctaDescription:
            'Prueba Wan 2.6 ahora y convierte tus ideas en videos increíbles',
        ctaButton: 'Probar Wan 2.6 ahora',
        ctaDisclaimer: 'Sin tarjeta de crédito: regístrate y empieza',

        // 视频播放相关
        videoNotSupported: 'Tu navegador no admite la reproducción de video',
        videoLoadingError: 'No se pudo cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // 页面标题和描述
        pageTitle:
            'Générateur de vidéo Wan 2.6 - Plateforme de création vidéo IA multimodale nouvelle génération',
        pageDescription:
            'Découvrez Wan 2.6, le modèle multimodal IA phare de génération vidéo. Il produit des vidéos 1080p de qualité cinéma et franchit un cap avec le Native Audio-Visual Sync : image et audio (effets, voix) synchronisés générés en une seule fois. Essai gratuit sur WeryAI.',
        pageKeywords:
            'Wan 2.6, générateur de vidéo IA, modèle vidéo IA multimodal, synchronisation native audio-visuelle, 1080p cinéma, storyboard intelligent, vidéo IA gratuite, WeryAI, création vidéo',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Modèle multimodal IA phare de génération vidéo',
        short_title: 'Modèle vidéo IA multimodal',
        generatorDescription:
            'WeryAI intègre désormais en profondeur le modèle Wan 2.6, Wan 2.6 est le tout dernier modèle multimodal IA phare publié par l’équipe Tongyi Wanxiang (Wanx) d’Alibaba Cloud. En tant que mise à niveau majeure de la série Wan, il prend en charge une sortie 1080p de qualité cinéma et réalise une avancée avec le Native Audio-Visual Sync : il génère l’image en même temps que des effets sonores et des voix parfaitement assortis, en une seule passe. Conçu pour résoudre les défis de narration en vidéo longue, Wan 2.6 intègre un storyboard multi‑plans intelligent permettant jusqu’à 15 secondes de création cohérente multi‑caméra, pour aider les créateurs à passer “du script au montage final”. Essayez Wan 2.6 gratuitement sur WeryAI et entrez dans une nouvelle ère de création IA, avec image et son.',
        generatorDescriptionHighlight1:
            'Wan 2.6 est désormais intégré au générateur vidéo WeryAI pour créer des vidéos réalistes',
        generatorDescriptionText2: '. Cliquez ici pour',
        generatorDescriptionHighlight2: 'essayer Wan 2.6 gratuitement',
        generatorDescriptionEnd: ' !',

        // 标签页
        tabImageToVideo: 'Image → Vidéo',
        tabTextToVideo: 'Texte → Vidéo',

        // 核心功能部分
        coreFeaturesTitle: 'Fonctionnalités clés de Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Génération avec synchronisation native audio‑visuelle',
        nativeAudioIntegrationDescription:
            'Wan 2.6 dépasse la frontière entre le visuel et l’audio : lors de la génération de la vidéo, il peut créer automatiquement un son synchronisé avec précision (ex. pas, pluie) et même des dialogues avec lip‑sync, pour fournir des assets audiovisuels complets sans doublage en post‑production.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Narration multi‑plans intelligente',
        enhancedDynamicEffectsDescription:
            'Grâce à une compréhension sémantique puissante, le modèle peut décomposer un long prompt complexe en plusieurs plans (ex. plan large puis gros plan) et maintenir une forte cohérence des personnages, des scènes et de l’éclairage d’un plan à l’autre, racontant une histoire complète en une seule génération.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle:
            'Reproduction d’interprétation et de mouvement',
        preciseCameraControlDescription:
            'Avec “vidéo vers vidéo”, vous pouvez importer une vidéo de performance réelle comme référence. Wan 2.6 transfère avec précision l’amplitude des mouvements, les expressions faciales et même le rythme de la caméra vers un personnage virtuel nouvellement généré (anime ou 3D), réalisant une “capture de mouvement IA”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Génération longue cohérente jusqu’à 15 secondes',
        enhancedVisualRealismDescription:
            'Générez jusqu’à 15 secondes de vidéo HD en 1080p/24fps. Par rapport aux clips courts des modèles traditionnels, Wan 2.6 offre plus de temps pour illustrer des actions complexes et des changements d’environnement, tout en conservant une qualité stable du début à la fin.',

        // 如何使用部分
        howToUseTitle: 'Comment utiliser Wan 2.6 sur WeryAI',
        step1Title: 'Choisir le modèle',
        step1Description:
            'Dans l’outil de vidéo IA, sélectionnez le modèle Wan 2.6',
        step2Title: 'Saisir le contenu',
        step2Description:
            'Décrivez la scène dans la zone de texte ou importez une image/vidéo de référence pour activer “Image → Vidéo” ou la “Reproduction d’interprétation et de mouvement”.',
        step3Title: 'Générer la vidéo',
        step3Description:
            'Réglez les paramètres (ex. format 16:9, durée 15 s), cliquez sur “Générer”, puis prévisualisez et téléchargez votre vidéo avec son.',

        // YouTube 视频部分
        youtubeTitle: 'Vidéos YouTube à propos du modèle vidéo Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Posts X populaires à propos du modèle vidéo IA Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Découvrir d’autres modèles',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Générateur vidéo IA Google Veo 3.1',
        sora2Title: 'Générateur vidéo IA OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Questions fréquentes',

        // CTA 部分
        ctaTitle: 'Prêt à créer ?',
        ctaDescription:
            'Essayez Wan 2.6 dès maintenant et transformez vos idées en superbes vidéos',
        ctaButton: 'Essayer Wan 2.6',
        ctaDisclaimer:
            'Aucune carte bancaire requise — inscrivez-vous pour commencer',

        // 视频播放相关
        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Videogenerator - Multimodale KI-Videoplattform der nächsten Generation',
        pageDescription:
            'Erlebe Wan 2.6, ein multimodales KI-Flaggschiff für Videogenerierung. Es liefert filmreife 1080p-Videos und einen Durchbruch bei Native Audio-Visual Sync: Bild und passender Ton (Effekte, Stimme) entstehen in einem Durchlauf. Kostenlos auf WeryAI testen.',
        pageKeywords:
            'Wan 2.6, KI Videogenerator, multimodales KI Videomodell, native Audio-Visual Sync, filmreife 1080p, intelligentes Storyboarding, kostenloses KI Video, WeryAI, Videoproduktion',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Multimodales KI-Flaggschiff für Videogenerierung',
        short_title: 'Multimodales KI-Videomodell',
        generatorDescription:
            'WeryAI integriert jetzt das Modell Wan 2.6 tiefgreifend, Wan 2.6 ist das neueste multimodale KI-Flaggschiff zur Videogenerierung, veröffentlicht vom Tongyi Wanxiang (Wanx) Team von Alibaba Cloud. Als großes Upgrade der Wan-Serie unterstützt es nicht nur filmreife 1080p-Ausgabe, sondern erreicht auch einen Durchbruch bei Native Audio-Visual Sync: Es erzeugt Bildmaterial zusammen mit passenden Soundeffekten und Stimmen in einem einzigen Durchlauf. Entwickelt für die Herausforderungen längerer Erzählformate, bietet Wan 2.6 intelligentes Multi‑Shot‑Storyboarding für bis zu 15 Sekunden kohärente, mehrkameraartige Erstellung – ideal, um “vom Skript zum finalen Schnitt” zu gelangen. Teste Wan 2.6 kostenlos auf WeryAI und erlebe eine neue Ära der KI‑Kreation – mit Bild und Ton.',
        generatorDescriptionHighlight1:
            'Wan 2.6 ist jetzt im WeryAI Videogenerator integriert und erstellt realistische Videos',
        generatorDescriptionText2: '. Klicke hier, um',
        generatorDescriptionHighlight2: 'Wan 2.6 kostenlos zu testen',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // 核心功能部分
        coreFeaturesTitle: 'Kernfunktionen von Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native Audio-Visual Sync-Generierung',
        nativeAudioIntegrationDescription:
            'Wan 2.6 hebt die Grenze zwischen Sehen und Hören auf: Während das Video entsteht, erzeugt es automatisch präzise synchronisierten Ton (z. B. Schritte, Regen) und sogar Dialoge mit Lippen‑Sync – für vollständige audiovisuelle Assets ohne nachträgliches Dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligentes Multi‑Shot‑Storytelling',
        enhancedDynamicEffectsDescription:
            'Dank starker semantischer Verständniskraft kann das Modell einen komplexen, langen Prompt in mehrere Shots (z. B. Weitwinkel zu Nahaufnahme) zerlegen und dabei Charaktere, Szenen sowie Lichtstimmung zwischen den Shots sehr konsistent halten – so entsteht in einem Durchlauf eine komplette Mini‑Story.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- & Bewegungsrekonstruktion',
        preciseCameraControlDescription:
            'Mit “Video‑zu‑Video” kannst du einen realen Performance‑Clip als Referenz hochladen. Wan 2.6 überträgt Bewegungsumfang, Mimik und sogar das Kamerarhythmusgefühl präzise auf eine neu generierte virtuelle Figur (z. B. Anime oder 3D) – das ermöglicht “KI‑Motion‑Capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Kohärente 15‑Sekunden‑Langvideo‑Generierung',
        enhancedVisualRealismDescription:
            'Erzeuge bis zu 15 Sekunden 1080p/24fps‑HD‑Video. Im Vergleich zu kurzen Clips traditioneller Modelle bietet Wan 2.6 mehr Zeit für komplexe Aktionen und Umgebungswechsel – bei stabiler, hochwertiger Bildqualität über die gesamte Dauer.',

        // 如何使用部分
        howToUseTitle: 'So verwendest du Wan 2.6 auf WeryAI',
        step1Title: 'Modell auswählen',
        step1Description: 'Wähle im KI‑Video‑Tool das Modell Wan 2.6 aus',
        step2Title: 'Inhalt eingeben',
        step2Description:
            'Beschreibe die gewünschte Szene im Textfeld oder lade ein Referenzbild/-video hoch, um „Bild zu Video“ oder „Performance- & Bewegungsrekonstruktion“ zu nutzen.',
        step3Title: 'Video generieren',
        step3Description:
            'Lege Parameter fest (z. B. 16:9, 15 Sekunden) und klicke auf „Generieren“. Nach kurzer Zeit kannst du dein Video mit Sound ansehen und herunterladen.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube‑Videos über das Wan 2.6 Videomodell',

        // X Posts 部分
        xPostsTitle: 'Beliebte X‑Posts über das Wan 2.6 KI‑Videomodell',

        // 探索其他模型部分
        exploreModelsTitle: 'Weitere Modelle entdecken',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 KI‑Videogenerator',
        sora2Title: 'OpenAI Sora‑2 KI‑Videogenerator',

        // FAQ 部分
        faqTitle: 'Häufige Fragen',

        // CTA 部分
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription:
            'Teste Wan 2.6 jetzt und verwandle deine Ideen in beeindruckende Videos',
        ctaButton: 'Wan 2.6 jetzt testen',
        ctaDisclaimer:
            'Keine Kreditkarte erforderlich — registrieren und loslegen',

        // 视频播放相关
        videoNotSupported: 'Dein Browser unterstützt die Videowiedergabe nicht',
        videoLoadingError: 'Video konnte nicht geladen werden',
        videoReload: 'Neu laden',
    },
    ru: {
        // 页面标题和描述
        pageTitle:
            'Генератор видео Wan 2.6 - Платформа создания видео с мультимодальным ИИ нового поколения',
        pageDescription:
            'Попробуйте Wan 2.6 — флагманскую мультимодальную модель генерации видео. Она создаёт кинематографическое видео 1080p и предлагает прорыв Native Audio-Visual Sync: картинка и синхронный звук (эффекты, голос) генерируются за один проход. Бесплатно на WeryAI.',
        pageKeywords:
            'Wan 2.6, генератор видео ИИ, мультимодальная модель видео ИИ, нативная аудио-визуальная синхронизация, 1080p кино, умный сторибординг, бесплатное ИИ видео, WeryAI, создание видео',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 — флагманская мультимодальная модель генерации видео',
        short_title: 'Мультимодальная модель ИИ для видео',
        generatorDescription:
            'WeryAI теперь глубоко интегрировал модель Wan 2.6, Wan 2.6 — новейшая флагманская мультимодальная модель генерации видео от команды Tongyi Wanxiang (Wanx) Alibaba Cloud. Это крупное обновление серии Wan: помимо кинематографического 1080p, модель делает прорыв в Native Audio-Visual Sync — генерирует изображение вместе с подходящими звуковыми эффектами и голосом за один проход. Wan 2.6 создана для сложных задач длинного повествования и включает умное многокадровое сторибордирование, позволяющее до 15 секунд связной мультикадровой генерации, чтобы создатели могли перейти “от сценария к финальному монтажу”. Попробуйте Wan 2.6 бесплатно на WeryAI и откройте новую эру ИИ‑творчества — со звуком и картинкой.',
        generatorDescriptionHighlight1:
            'Wan 2.6 уже интегрирована в видеогенератор WeryAI и создаёт реалистичные видео',
        generatorDescriptionText2: '. Нажмите здесь, чтобы',
        generatorDescriptionHighlight2: 'попробовать Wan 2.6 бесплатно',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Изображение → Видео',
        tabTextToVideo: 'Текст → Видео',

        // 核心功能部分
        coreFeaturesTitle: 'Ключевые возможности Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Нативная генерация с аудио‑визуальной синхронизацией',
        nativeAudioIntegrationDescription:
            'Wan 2.6 стирает границу между изображением и звуком: одновременно с видеорядом она автоматически генерирует точно синхронизированный звук (например, шаги, дождь) и даже реплики с лип‑синком, предоставляя полноценные аудио‑визуальные материалы без пост‑дубляжа.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle:
            'Интеллектуальный многокадровый сторителлинг',
        enhancedDynamicEffectsDescription:
            'Благодаря сильному семантическому пониманию модель разбивает сложный длинный промпт на несколько планов (например, общий → крупный) и сохраняет высокую согласованность персонажей, сцен и света между планами — так за одну генерацию получается цельная мини‑история.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Реконструкция игры и движений',
        preciseCameraControlDescription:
            'С “video‑to‑video” вы можете загрузить реальный ролик‑референс. Wan 2.6 точно переносит амплитуду движений, мимику и даже ритм камеры на нового виртуального персонажа (например, аниме или 3D), реализуя “ИИ‑моушн‑кэпчер”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Связная генерация длинного видео до 15 секунд',
        enhancedVisualRealismDescription:
            'Генерируйте до 15 секунд HD‑видео 1080p/24fps. По сравнению с короткими клипами традиционных моделей Wan 2.6 даёт больше времени для сложных действий и изменений окружения, сохраняя стабильное качество на всём протяжении.',

        // 如何使用部分
        howToUseTitle: 'Как пользоваться Wan 2.6 на WeryAI',
        step1Title: 'Выберите модель',
        step1Description: 'В инструменте AI Video выберите модель Wan 2.6',
        step2Title: 'Введите контент',
        step2Description:
            'Опишите желаемую сцену в текстовом поле или загрузите референс‑изображение/видео, чтобы включить “Изображение → Видео” или “Реконструкция игры и движений”.',
        step3Title: 'Сгенерируйте видео',
        step3Description:
            'Настройте параметры (например, 16:9 и длительность 15 секунд), нажмите “Сгенерировать” — через пару мгновений сможете просмотреть и скачать видео со звуком.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube‑видео о видеомодели Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Популярные посты в X о модели AI‑видео Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Посмотреть другие модели',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Генератор AI‑видео Google Veo 3.1',
        sora2Title: 'Генератор AI‑видео OpenAI Sora‑2',

        // FAQ 部分
        faqTitle: 'Часто задаваемые вопросы',

        // CTA 部分
        ctaTitle: 'Готовы начать творить?',
        ctaDescription:
            'Попробуйте Wan 2.6 прямо сейчас и превратите идеи в отличные видео',
        ctaButton: 'Попробовать Wan 2.6',
        ctaDisclaimer: 'Без кредитной карты — зарегистрируйтесь и начинайте',

        // 视频播放相关
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Не удалось загрузить видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // 页面标题和描述
        pageTitle:
            'Gerador de vídeo Wan 2.6 - Plataforma de criação de vídeo com IA multimodal de nova geração',
        pageDescription:
            'Experimente o Wan 2.6, o modelo multimodal flagship de geração de vídeo por IA. Ele entrega vídeo 1080p com qualidade cinematográfica e um avanço em Native Audio-Visual Sync: gera imagem e áudio (efeitos e voz) sincronizados em uma única execução. Teste grátis na WeryAI.',
        pageKeywords:
            'Wan 2.6, gerador de vídeo IA, modelo de vídeo IA multimodal, sincronização nativa áudio-visual, 1080p cinematográfico, storyboard inteligente, vídeo IA grátis, WeryAI, criação de vídeo',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Modelo multimodal flagship de geração de vídeo por IA',
        short_title: 'Modelo de vídeo de IA multimodal',
        generatorDescription:
            'O WeryAI agora integra profundamente o modelo Wan 2.6, Wan 2.6 é o mais recente modelo multimodal flagship lançado pela equipe Tongyi Wanxiang (Wanx) da Alibaba Cloud. Como uma grande atualização da série Wan, ele não só suporta saída 1080p com qualidade cinematográfica, como também traz um avanço em Native Audio-Visual Sync — gerando o vídeo junto com efeitos sonoros e vozes compatíveis em uma única passada. Criado para enfrentar os desafios de narrativas mais longas, o Wan 2.6 conta com storyboard inteligente multi‑cenas, permitindo até 15 segundos de criação coerente com múltiplos planos e ajudando criadores a ir “do roteiro ao corte final”. Experimente o Wan 2.6 grátis na WeryAI e entre numa nova era de criação com IA, com imagem e som.',
        generatorDescriptionHighlight1:
            'O Wan 2.6 já está integrado ao gerador de vídeo da WeryAI para criar vídeos realistas',
        generatorDescriptionText2: '. Clique aqui para',
        generatorDescriptionHighlight2: 'testar o Wan 2.6 grátis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Imagem para vídeo',
        tabTextToVideo: 'Texto para vídeo',

        // 核心功能部分
        coreFeaturesTitle: 'Principais recursos do Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Geração com sincronização nativa áudio‑visual',
        nativeAudioIntegrationDescription:
            'O Wan 2.6 rompe a barreira entre visão e audição: ao mesmo tempo em que gera o vídeo, cria automaticamente áudio sincronizado com precisão (ex.: passos, chuva) e até diálogos com lip‑sync, entregando materiais audiovisuais completos sem dublagem posterior.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle:
            'Storytelling inteligente em múltiplas cenas',
        enhancedDynamicEffectsDescription:
            'Com forte compreensão semântica, o modelo decompõe um prompt longo e complexo em várias cenas (ex.: plano geral para close) e mantém alta consistência de personagem, cenário e iluminação entre as cenas, contando uma mini‑história completa em uma única geração.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Reencenação de performance e movimento',
        preciseCameraControlDescription:
            'Com “vídeo para vídeo”, você pode enviar um clipe de performance real como referência. O Wan 2.6 transfere com precisão a amplitude dos movimentos, expressões faciais e até o ritmo de câmera para um personagem virtual recém‑gerado (ex.: anime ou 3D), realizando “captura de movimento com IA”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Geração coerente de vídeo longo de 15 segundos',
        enhancedVisualRealismDescription:
            'Gere até 15 segundos de vídeo HD em 1080p/24fps. Em comparação com clipes curtos de modelos tradicionais, o Wan 2.6 oferece mais tempo para mostrar ações complexas e mudanças de ambiente, mantendo qualidade estável do começo ao fim.',

        // 如何使用部分
        howToUseTitle: 'Como usar o Wan 2.6 na WeryAI',
        step1Title: 'Escolha o modelo',
        step1Description:
            'Selecione o modelo Wan 2.6 na ferramenta de vídeo com IA',
        step2Title: 'Insira o conteúdo',
        step2Description:
            'Descreva a cena na caixa de texto ou envie uma imagem/vídeo de referência para ativar “Imagem para vídeo” ou “Reencenação de performance e movimento”.',
        step3Title: 'Gerar vídeo',
        step3Description:
            'Defina os parâmetros (ex.: proporção 16:9, duração de 15 s), clique em “Gerar” e em instantes você poderá visualizar e baixar seu vídeo com som.',

        // YouTube 视频部分
        youtubeTitle: 'Vídeos no YouTube sobre o modelo de vídeo Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Posts em alta no X sobre o modelo de vídeo IA Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Explorar outros modelos',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Gerador de vídeo IA Google Veo 3.1',
        sora2Title: 'Gerador de vídeo IA OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Perguntas frequentes',

        // CTA 部分
        ctaTitle: 'Pronto para começar a criar?',
        ctaDescription:
            'Experimente o Wan 2.6 agora e transforme suas ideias em vídeos incríveis',
        ctaButton: 'Experimentar Wan 2.6 agora',
        ctaDisclaimer: 'Sem cartão de crédito — cadastre-se para começar',

        // 视频播放相关
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // 页面标题和描述
        pageTitle:
            'Generatore video Wan 2.6 - Piattaforma di creazione video AI multimodale di nuova generazione',
        pageDescription:
            'Prova Wan 2.6, il modello multimodale di punta per la generazione di video con AI. Offre video 1080p in qualità cinematografica e un salto con Native Audio-Visual Sync: genera immagini e audio (effetti e voce) sincronizzati in un’unica esecuzione. Provalo gratis su WeryAI.',
        pageKeywords:
            'Wan 2.6, generatore video AI, modello video AI multimodale, sincronizzazione nativa audio-visiva, 1080p cinematografico, storyboard intelligente, video AI gratis, WeryAI, creazione video',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - Modello multimodale di punta per la generazione video con AI',
        short_title: 'Modello video IA multimodale',
        generatorDescription:
            'WeryAI integra ora in profondità il modello Wan 2.6, Wan 2.6 è il più recente modello multimodale di punta rilasciato dal team Tongyi Wanxiang (Wanx) di Alibaba Cloud. Come grande aggiornamento della serie Wan, non solo supporta output 1080p in qualità cinematografica, ma raggiunge anche un progresso con Native Audio-Visual Sync, generando il video insieme a effetti sonori e voci coerenti in un solo passaggio. Pensato per affrontare la narrativa nei video lunghi, Wan 2.6 include uno storyboard intelligente multi‑inquadratura che consente fino a 15 secondi di creazione coerente multi‑shot, aiutando i creator a passare “dalla sceneggiatura al montaggio finale”. Prova Wan 2.6 gratis su WeryAI e vivi una nuova era di creazione AI, con immagini e suono.',
        generatorDescriptionHighlight1:
            'Wan 2.6 è ora integrato nel generatore video WeryAI per creare video realistici',
        generatorDescriptionText2: '. Clicca qui per',
        generatorDescriptionHighlight2: 'provare Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Immagine → Video',
        tabTextToVideo: 'Testo → Video',

        // 核心功能部分
        coreFeaturesTitle: 'Funzionalità chiave di Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle:
            'Generazione con sincronizzazione nativa audio‑visiva',
        nativeAudioIntegrationDescription:
            'Wan 2.6 supera il confine tra vista e udito: mentre genera il video, crea automaticamente audio sincronizzato con precisione (es. passi, pioggia) e persino dialoghi con lip‑sync, fornendo asset audiovisivi completi senza doppiaggio in post‑produzione.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle:
            'Storytelling intelligente multi‑inquadratura',
        enhancedDynamicEffectsDescription:
            'Grazie a una forte comprensione semantica, il modello può scomporre un prompt lungo e complesso in più inquadrature (es. campo lungo → primo piano) e mantenere alta coerenza di personaggi, scena e illuminazione tra le inquadrature, raccontando una mini‑storia completa in una sola generazione.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Re-enactment di performance e movimento',
        preciseCameraControlDescription:
            'Con “video‑to‑video” puoi caricare una clip di performance reale come riferimento. Wan 2.6 trasferisce con precisione ampiezza dei movimenti, espressioni facciali e persino il ritmo della camera su un personaggio virtuale appena generato (es. anime o 3D), ottenendo una “motion capture con AI”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle:
            'Generazione coerente di video lunghi fino a 15 secondi',
        enhancedVisualRealismDescription:
            'Genera fino a 15 secondi di video HD 1080p/24fps. Rispetto ai clip brevi dei modelli tradizionali, Wan 2.6 offre più tempo per mostrare azioni complesse e cambi ambientali, mantenendo una qualità stabile dall’inizio alla fine.',

        // 如何使用部分
        howToUseTitle: 'Come usare Wan 2.6 su WeryAI',
        step1Title: 'Scegli il modello',
        step1Description:
            'Nello strumento AI Video, seleziona il modello Wan 2.6',
        step2Title: 'Inserisci il contenuto',
        step2Description:
            'Descrivi la scena nella casella di testo oppure carica un’immagine/video di riferimento per attivare “Immagine → Video” o “Re-enactment di performance e movimento”.',
        step3Title: 'Genera il video',
        step3Description:
            'Imposta i parametri (es. formato 16:9, durata 15 s), fai clic su “Genera” e dopo poco potrai visualizzare e scaricare il tuo video con audio.',

        // YouTube 视频部分
        youtubeTitle: 'Video YouTube sul modello video Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Post X di tendenza sul modello video AI Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Esplora altri modelli',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Generatore video AI Google Veo 3.1',
        sora2Title: 'Generatore video AI OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'Domande frequenti',

        // CTA 部分
        ctaTitle: 'Pronto a iniziare a creare?',
        ctaDescription:
            'Prova Wan 2.6 ora e trasforma le tue idee in video fantastici',
        ctaButton: 'Prova Wan 2.6 ora',
        ctaDisclaimer:
            'Nessuna carta di credito richiesta — registrati per iniziare',

        // 视频播放相关
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Impossibile caricare il video',
        videoReload: 'Ricarica',
    },
    ar: {
        // 页面标题和描述
        pageTitle:
            'مولّد الفيديو Wan 2.6 - منصة إنشاء فيديو بالذكاء الاصطناعي متعدد الوسائط من الجيل الجديد',
        pageDescription:
            'جرّب Wan 2.6، نموذجًا رائدًا لتوليد الفيديو بالذكاء الاصطناعي متعدد الوسائط. يقدّم فيديو 1080p بجودة سينمائية مع طفرة في Native Audio-Visual Sync: توليد الصورة والصوت المتزامن (المؤثرات والصوت البشري) دفعة واحدة. جرّبه مجانًا على WeryAI.',
        pageKeywords:
            'Wan 2.6, مولد فيديو بالذكاء الاصطناعي, نموذج فيديو متعدد الوسائط, مزامنة أصلية للصوت والصورة, 1080p سينمائي, ستوري بورد ذكي, فيديو بالذكاء الاصطناعي مجاني, WeryAI, إنشاء الفيديو',

        // 生成器部分
        generatorTitle:
            'Wan 2.6 - النموذج الرائد متعدد الوسائط لتوليد الفيديو بالذكاء الاصطناعي',
        short_title: 'نموذج فيديو ذكاء اصطناعي متعدد الوسائط',
        generatorDescription:
            'يقوم WeryAI الآن بدمج نموذج Wan 2.6 بعمق، Wan 2.6 هو أحدث نموذج رائد متعدد الوسائط لتوليد الفيديو بالذكاء الاصطناعي أطلقه فريق Tongyi Wanxiang (Wanx) من Alibaba Cloud. وبصفته ترقية كبرى لسلسلة Wan، فهو لا يدعم إخراج 1080p بجودة سينمائية فحسب، بل يحقق أيضًا إنجازًا في Native Audio-Visual Sync عبر توليد المشهد مع المؤثرات الصوتية والأصوات المتطابقة في تمريرة واحدة. صُمّم Wan 2.6 لحل تحديات السرد في الفيديوهات الطويلة، ويضم ميزة تقسيم اللقطات الذكية متعددة المشاهد التي تتيح حتى 15 ثانية من إنشاء متماسك متعدد اللقطات، لمساعدة المبدعين على الانتقال “من النص إلى النسخة النهائية”. جرّب Wan 2.6 مجانًا على WeryAI وادخل عصرًا جديدًا من الإبداع بالذكاء الاصطناعي مع الصورة والصوت.',
        generatorDescriptionHighlight1:
            'تم دمج Wan 2.6 الآن في مولّد الفيديو WeryAI لإنشاء فيديوهات واقعية',
        generatorDescriptionText2: '. انقر هنا لـ',
        generatorDescriptionHighlight2: 'تجربة Wan 2.6 مجانًا',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // 核心功能部分
        coreFeaturesTitle: 'الميزات الأساسية في Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'توليد بمزامنة أصلية للصوت والصورة',
        nativeAudioIntegrationDescription:
            'يكسر Wan 2.6 الحاجز بين البصر والسمع: أثناء توليد الفيديو، يمكنه إنشاء صوت متزامن بدقة (مثل خطوات الأقدام والمطر) وحتى حوار مع تزامن حركة الشفاه، لتقديم مواد سمعية‑بصرية مكتملة دون دبلجة لاحقة.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'سرد ذكي متعدد اللقطات',
        enhancedDynamicEffectsDescription:
            'بفضل فهم دلالي قوي، يستطيع النموذج تفكيك تعليمات طويلة ومعقدة إلى عدة لقطات (مثل لقطة عامة ثم مقرّبة)، مع الحفاظ على اتساق الشخصية والمشهد والإضاءة بين اللقطات، ليروي قصة قصيرة كاملة في توليد واحد.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'إعادة تمثيل الأداء والحركة',
        preciseCameraControlDescription:
            'باستخدام “video-to-video”، يمكنك رفع مقطع أداء حقيقي كمرجع. يستطيع Wan 2.6 نقل مدى الحركة وتعابير الوجه وحتى إيقاع حركة الكاميرا بدقة إلى شخصية افتراضية مُولّدة حديثًا (مثل الأنمي أو 3D)، محققًا “التقاط حركة بالذكاء الاصطناعي”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'توليد فيديو طويل متماسك حتى 15 ثانية',
        enhancedVisualRealismDescription:
            'ولّد حتى 15 ثانية من فيديو HD بدقة 1080p/24fps. مقارنة بالمقاطع القصيرة في النماذج التقليدية، يمنح Wan 2.6 وقتًا أطول لإظهار الحركات المعقدة وتغيّر البيئة مع الحفاظ على جودة ثابتة طوال المقطع.',

        // 如何使用部分
        howToUseTitle: 'كيفية استخدام Wan 2.6 على WeryAI',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Wan 2.6 داخل أداة فيديو الذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description:
            'صف المشهد الذي تريده في مربع النص، أو ارفع صورة/فيديو مرجعي لتفعيل “صورة إلى فيديو” أو “إعادة تمثيل الأداء والحركة”.',
        step3Title: 'ولّد الفيديو',
        step3Description:
            'اضبط الإعدادات (مثل نسبة 16:9 ومدة 15 ثانية)، ثم اضغط “توليد”. بعد لحظات يمكنك المعاينة والتنزيل لفيديوك مع الصوت.',

        // YouTube 视频部分
        youtubeTitle: 'فيديوهات YouTube عن نموذج الفيديو Wan 2.6',

        // X Posts 部分
        xPostsTitle:
            'منشورات X الرائجة عن نموذج فيديو الذكاء الاصطناعي Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'استكشف نماذج أخرى',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'مولّد فيديو بالذكاء الاصطناعي Google Veo 3.1',
        sora2Title: 'مولّد فيديو بالذكاء الاصطناعي OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'الأسئلة الشائعة',

        // CTA 部分
        ctaTitle: 'هل أنت مستعد لبدء الإبداع؟',
        ctaDescription: 'جرّب Wan 2.6 الآن وحوّل أفكارك إلى فيديوهات رائعة',
        ctaButton: 'جرّب Wan 2.6 الآن',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان — سجّل لتبدأ',

        // 视频播放相关
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Generator - แพลตฟอร์มสร้างวิดีโอ AI มัลติโหมดรุ่นใหม่',
        pageDescription:
            'ลอง Wan 2.6 โมเดลสร้างวิดีโอ AI มัลติโหมดระดับเรือธง ให้ภาพระดับภาพยนตร์ 1080p และการซิงก์เสียง-ภาพแบบเนทีฟ สร้างภาพพร้อมเอฟเฟกต์เสียงและเสียงพูดในครั้งเดียว ทดลองใช้ฟรีบน WeryAI',
        pageKeywords:
            'Wan 2.6, เครื่องมือสร้างวิดีโอ AI, โมเดลวิดีโอ AI มัลติโหมด, ซิงก์เสียง-ภาพแบบเนทีฟ, 1080p ระดับภาพยนตร์, สตอรี่บอร์ดอัจฉริยะ, วิดีโอ AI ฟรี, WeryAI, การสร้างวิดีโอ',

        // 生成器部分
        generatorTitle: 'โมเดลสร้างวิดีโอ AI มัลติโหมดระดับเรือธง Wan 2.6',
        short_title: 'โมเดลวิดีโอ AI มัลติโหมด',
        generatorDescription:
            'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Wan 2.6 อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Wan 2.6 อย่างลึกซึ้งแล้ว Wan 2.6 คือโมเดลสร้างวิดีโอ AI มัลติโหมดระดับเรือธงรุ่นล่าสุดจากทีม Tongyi Wanxiang (Wanx) ของ Alibaba Cloud ในฐานะการอัปเกรดครั้งใหญ่ของตระกูล Wan นอกจากรองรับเอาต์พุตระดับภาพยนตร์ 1080p แล้วยังสร้างความก้าวหน้าด้วยการซิงก์เสียง-ภาพแบบเนทีฟ สร้างภาพพร้อมเอฟเฟกต์เสียงและเสียงพูดในครั้งเดียว ออกแบบมาเพื่อการเล่าเรื่องแบบยาว Wan 2.6 มาพร้อมสตอรี่บอร์ดหลายช็อตอัจฉริยะที่สร้างวิดีโอหลายมุมกล้องอย่างต่อเนื่องได้สูงสุด 15 วินาที ช่วยให้ครีเอเตอร์ไปจากสคริปต์สู่ชิ้นงานสุดท้ายได้ ลอง Wan 2.6 ฟรีบน WeryAI แล้วก้าวสู่ยุคใหม่ของ “วิดีโอมีเสียง สร้างโดย AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 ถูกผสานเข้ากับเครื่องมือสร้างวิดีโอ WeryAI เพื่อสร้างวิดีโอสมจริงแล้ว',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'ลอง Wan 2.6 ฟรี',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // 核心功能部分
        coreFeaturesTitle: 'คุณสมบัติเด่นของ Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'การสร้างซิงก์เสียง-ภาพแบบเนทีฟ',
        nativeAudioIntegrationDescription:
            'Wan 2.6 ทำลายขีดจำกัดระหว่างภาพและเสียง ระหว่างสร้างวิดีโอสามารถสร้างเสียงที่ซิงก์อย่างแม่นยำ (เช่น เสียงเท้า เสียงฝน) และแม้แต่ลิปซิงก์บทสนทนา ทำให้ได้ชิ้นงานภาพ-เสียงครบโดยไม่ต้องพากย์ทีหลัง',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'การเล่าเรื่องหลายช็อตอัจฉริยะ',
        enhancedDynamicEffectsDescription:
            'ด้วยความเข้าใจเชิงความหมายที่แข็งแรง โมเดลสามารถแยกพรอมต์ยาวและซับซ้อนเป็นหลายช็อต (เช่น มุมกว้างไปโคลสอัป) พร้อมคงเอกลักษณ์ตัวละคร ฉาก และแสงให้สอดคล้องกันตลอด เพื่อเล่าเรื่องสั้นให้จบในครั้งเดียว',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'การรีเอนแอคท์การแสดงและการเคลื่อนไหว',
        preciseCameraControlDescription:
            'ด้วย “video-to-video” คุณสามารถอัปโหลดคลิปการแสดงจริงเป็นอ้างอิง Wan 2.6 จะถ่ายทอดช่วงการเคลื่อนไหว สีหน้า และแม้แต่จังหวะกล้องไปยังตัวละครเสมือนใหม่ (เช่น อนิเมะหรือ 3D) เสมือน “AI motion capture”',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'การสร้างวิดีโอยาว 15 วินาทีแบบต่อเนื่อง',
        enhancedVisualRealismDescription:
            'สร้างวิดีโอ HD 1080p/24fps ได้ยาวถึง 15 วินาที เมื่อเทียบกับคลิปสั้นจากโมเดลเดิม Wan 2.6 มีเวลามากขึ้นในการถ่ายทอดการกระทำที่ซับซ้อนและการเปลี่ยนแปลงสภาพแวดล้อม โดยคงคุณภาพภาพที่เสถียรตลอด',

        // 如何使用部分
        howToUseTitle: 'วิธีใช้ Wan 2.6 บน WeryAI',
        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล Wan 2.6 ในเครื่องมือ AI Video',
        step2Title: 'ป้อนเนื้อหา',
        step2Description:
            'อธิบายฉากที่ต้องการในกล่องข้อความ หรืออัปโหลดภาพ/วิดีโออ้างอิงเพื่อใช้ “Image to Video” หรือ “Performance & Motion Re-enactment”',
        step3Title: 'สร้างวิดีโอ',
        step3Description:
            'ตั้งค่าพารามิเตอร์ (เช่น อัตราส่วน 16:9 ความยาว 15 วินาที) คลิก “Generate” แล้วรอสักครู่เพื่อพรีวิวและดาวน์โหลดวิดีโอพร้อมเสียง',

        // YouTube 视频部分
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลวิดีโอ Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'โพสต์มาแรงบน X เกี่ยวกับโมเดลวิดีโอ AI Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'สำรวจโมเดลอื่น ๆ',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        sora2Title: 'เครื่องมือสร้างวิดีโอ AI OpenAI Sora-2',

        // FAQ 部分
        faqTitle: 'คำถามที่พบบ่อย',

        // CTA 部分
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription:
            'ลอง Wan 2.6 ตอนนี้และเปลี่ยนไอเดียให้เป็นวิดีโอสุดพิเศษ',
        ctaButton: 'ลอง Wan 2.6 ตอนนี้',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต — สมัครเพื่อเริ่มต้น',

        // 视频播放相关
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadingError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 videogenerator - næste generations multimodale AI-videoplatform',
        pageDescription:
            'Prøv Wan 2.6, en multimodal AI-videomodel i flagskibsklassen. Den leverer filmisk 1080p-video og et gennembrud i indbygget lyd-billedsynk—genererer billeder sammen med matchende lydeffekter og stemmer i ét hug. Gratis at prøve på WeryAI.',
        pageKeywords:
            'Wan 2.6, AI-videogenerator, multimodal AI-videomodel, indbygget lyd-billedsynk, filmisk 1080p, intelligent storyboarding, gratis AI-video, WeryAI, videoskabelse',

        // 生成器部分
        generatorTitle: 'Wan 2.6 flagskibs multimodal AI-videomodel',
        short_title: 'Multimodal AI-videomodel',
        generatorDescription:
            'WeryAI har nu integreret modellen Wan 2.6 i dybden, Wan 2.6 er den nyeste multimodale AI-videomodel i flagskibsklassen fra Alibaba Clouds Tongyi Wanxiang (Wanx)-team. Som en stor opgradering i Wan-serien understøtter den ikke kun filmisk 1080p-output, men opnår også et gennembrud i indbygget lyd-billedsynk—den genererer billeder sammen med matchende lydeffekter og stemmer i én omgang. Wan 2.6 er skabt til long-form storytelling og har intelligent multi-shot storyboarding, der muliggør op til 15 sekunders sammenhængende, multi-kamera skabelse og hjælper skabere fra manuskript til færdig klipning. Prøv Wan 2.6 gratis på WeryAI og træd ind i en ny æra af “video med lyd, skabt af AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 er nu integreret i WeryAI-videogeneratoren for at skabe realistiske videoer',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'prøve Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 nøglefunktioner',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Indbygget lyd-billedsynk-generering',
        nativeAudioIntegrationDescription:
            'Wan 2.6 bryder grænsen mellem syn og lyd—mens videoen genereres, kan den automatisk skabe præcist synkroniseret lyd (fx fodtrin, regn) og endda lip-sync til karakterdialog, så du får komplette audiovisuelle assets uden efterdubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent multi-shot storytelling',
        enhancedDynamicEffectsDescription:
            'Med stærk semantisk forståelse kan modellen nedbryde en kompleks lang prompt til flere shots (fx total til nærbillede) og holde karakteridentitet, scener og lys meget konsistente på tværs af shots—så en komplet minihistorie fortælles i én generering.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- og bevægelsesre-enactment',
        preciseCameraControlDescription:
            'Med “video-to-video” kan du uploade et rigtigt performanceklip som reference. Wan 2.6 kan præcist overføre bevægelsesomfang, ansigtsudtryk og endda kamerapace til en nygenereret virtuel karakter (fx anime eller 3D) og muliggør “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Sammenhængende 15-sekunders video',
        enhancedVisualRealismDescription:
            'Generér op til 15 sekunders 1080p/24fps HD-video. Sammenlignet med korte klip fra traditionelle modeller giver Wan 2.6 mere tid til at skildre komplekse handlinger og miljøændringer, mens visuelle kvaliteter forbliver stabile hele vejen.',

        // 如何使用部分
        howToUseTitle: 'Sådan bruger du Wan 2.6 på WeryAI',
        step1Title: 'Vælg en model',
        step1Description: 'Vælg Wan 2.6-modellen i AI Video-værktøjet',
        step2Title: 'Indtast dit indhold',
        step2Description:
            'Beskriv scenen i tekstfeltet, eller upload et referencebillede/-video for at aktivere “Image to Video” eller “Performance & Motion Re-enactment”.',
        step3Title: 'Generér videoen',
        step3Description:
            'Indstil parametre (fx 16:9-format, 15 sekunders længde), klik “Generate”, og vent et øjeblik for at forhåndsvise og downloade din video med lyd.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube-videoer om Wan 2.6 videomodellen',

        // X Posts 部分
        xPostsTitle: 'Trending X-opslag om Wan 2.6 AI-videomodel',

        // 探索其他模型部分
        exploreModelsTitle: 'Udforsk andre modeller',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Ofte stillede spørgsmål',

        // CTA 部分
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaDescription:
            'Prøv Wan 2.6 nu og gør dine ideer til fantastiske videoer',
        ctaButton: 'Prøv Wan 2.6 nu',
        ctaDisclaimer: 'Intet kreditkort kræves — tilmeld dig for at starte',

        // 视频播放相关
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadingError: 'Kunne ikke indlæse video',
        videoReload: 'Genindlæs',
        },
    no: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 videogenerator - neste generasjon multimodal AI-videoplattform',
        pageDescription:
            'Prøv Wan 2.6, en flaggskip multimodal AI-videomodell. Den leverer filmatisk 1080p-video og et gjennombrudd i innebygd lyd-bildesynk—den genererer bilder sammen med matchende lydeffekter og stemmer i én omgang. Gratis å prøve på WeryAI.',
        pageKeywords:
            'Wan 2.6, AI-videogenerator, multimodal AI-videomodell, innebygd lyd-bildesynk, filmatisk 1080p, intelligent storyboarding, gratis AI-video, WeryAI, videoproduksjon',

        // 生成器部分
        generatorTitle: 'Wan 2.6 flaggskip multimodal AI-videomodell',
        short_title: 'Multimodal AI-videomodell',
        generatorDescription:
            'WeryAI har nå integrert modellen Wan 2.6 i dybden, Wan 2.6 er den nyeste flaggskip multimodale AI-videomodellen fra Alibaba Clouds Tongyi Wanxiang (Wanx)-team. Som en stor oppgradering i Wan-serien støtter den ikke bare filmatisk 1080p-utgang, men oppnår også et gjennombrudd i innebygd lyd-bildesynk—den genererer bilder sammen med matchende lydeffekter og stemmer i én omgang. Wan 2.6 er bygget for langformat storytelling og har intelligent multi-shot storyboarding som muliggjør opptil 15 sekunder sammenhengende, multikamera skapelse, og hjelper skapere fra manus til ferdig klipp. Prøv Wan 2.6 gratis på WeryAI og gå inn i en ny æra av “video med lyd, laget av AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 er nå integrert i WeryAI-videogeneratoren for å skape realistiske videoer',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'prøve Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 nøkkelfunksjoner',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Innebygd lyd-bildesynk-generering',
        nativeAudioIntegrationDescription:
            'Wan 2.6 bryter grensen mellom syn og lyd—mens videoen genereres kan den automatisk lage presist synkronisert lyd (f.eks. fottrinn, regn) og til og med lip-sync for dialog, slik at du får komplette audiovisuelle assets uten etterdubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligent multi-shot storytelling',
        enhancedDynamicEffectsDescription:
            'Med sterk semantisk forståelse kan modellen dele en kompleks lang prompt i flere shots (f.eks. total til nærbilde) og holde karakteridentitet, scener og lys svært konsistent på tvers av shots—og fortelle en komplett minihistorie i én generering.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- og bevegelsesre-enactment',
        preciseCameraControlDescription:
            'Med “video-to-video” kan du laste opp et ekte performanceklipp som referanse. Wan 2.6 kan presist overføre bevegelsesområde, ansiktsuttrykk og til og med kamerarytme til en nygenerert virtuell karakter (f.eks. anime eller 3D), og muliggjøre “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Sammenhengende 15-sekunders videogenerering',
        enhancedVisualRealismDescription:
            'Generer opptil 15 sekunder 1080p/24fps HD-video. Sammenlignet med korte klipp fra tradisjonelle modeller gir Wan 2.6 mer tid til å skildre komplekse handlinger og miljøendringer, samtidig som visuell kvalitet holdes stabil hele veien.',

        // 如何使用部分
        howToUseTitle: 'Slik bruker du Wan 2.6 på WeryAI',
        step1Title: 'Velg en modell',
        step1Description: 'Velg Wan 2.6-modellen i AI Video-verktøyet',
        step2Title: 'Skriv inn innholdet',
        step2Description:
            'Beskriv scenen i tekstfeltet, eller last opp referansebilde/-video for å aktivere “Image to Video” eller “Performance & Motion Re-enactment”.',
        step3Title: 'Generer videoen',
        step3Description:
            'Sett parametre (f.eks. 16:9-format, 15 sekunder varighet), klikk “Generate”, vent litt og forhåndsvis/last ned videoen med lyd.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube-videoer om Wan 2.6-videomodellen',

        // X Posts 部分
        xPostsTitle: 'Trending X-innlegg om Wan 2.6 AI-videomodell',

        // 探索其他模型部分
        exploreModelsTitle: 'Utforsk andre modeller',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Ofte stilte spørsmål',

        // CTA 部分
        ctaTitle: 'Klar til å starte?',
        ctaDescription:
            'Prøv Wan 2.6 nå og gjør ideene dine om til fantastiske videoer',
        ctaButton: 'Prøv Wan 2.6 nå',
        ctaDisclaimer: 'Ingen kredittkort nødvendig — registrer deg for å starte',

        // 视频播放相关
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadingError: 'Kunne ikke laste video',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 videogenerator - next-gen multimodaal AI-videoplatform',
        pageDescription:
            'Probeer Wan 2.6, een multimodaal AI-videomodel op vlaggenschipniveau. Het levert filmische 1080p-video en een doorbraak in native audio-visuele synchronisatie—genereert beelden samen met bijpassende geluidseffecten en stemmen in één keer. Gratis te proberen op WeryAI.',
        pageKeywords:
            'Wan 2.6, AI-videogenerator, multimodaal AI-videomodel, native audio-visuele sync, filmisch 1080p, intelligente storyboarding, gratis AI-video, WeryAI, videocreëer',

        // 生成器部分
        generatorTitle: 'Wan 2.6 vlaggenschip multimodaal AI-videomodel',
        short_title: 'Multimodaal AI-videomodel',
        generatorDescription:
            'WeryAI heeft het model Wan 2.6 nu diep geïntegreerd, Wan 2.6 is het nieuwste multimodale AI-videomodel op vlaggenschipniveau van het Tongyi Wanxiang (Wanx)-team van Alibaba Cloud. Als grote upgrade binnen de Wan-serie ondersteunt het niet alleen filmische 1080p-output, maar bereikt het ook een doorbraak in native audio-visuele synchronisatie—beelden worden samen met bijpassende geluidseffecten en stemmen in één keer gegenereerd. Wan 2.6 is gebouwd voor long-form storytelling en heeft intelligente multi-shot storyboarding die tot 15 seconden coherente, multi-camera creatie mogelijk maakt, zodat makers van script tot eindmontage kunnen gaan. Probeer Wan 2.6 gratis op WeryAI en stap in een nieuw tijdperk van “video met geluid, gemaakt door AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 is nu geïntegreerd in de WeryAI-videogenerator om realistische video\'s te maken',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'Wan 2.6 gratis proberen',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 kernfuncties',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Native audio-visuele synchronisatie',
        nativeAudioIntegrationDescription:
            'Wan 2.6 doorbreekt de grens tussen beeld en geluid—tijdens het genereren van de video kan het automatisch precies gesynchroniseerd audio (bijv. voetstappen, regen) en zelfs lip-sync voor dialogen maken, waardoor complete audiovisuele assets ontstaan zonder nabewerking met dubbing.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Intelligente multi-shot storytelling',
        enhancedDynamicEffectsDescription:
            'Met sterke semantische begrip kan het model een complexe lange prompt opdelen in meerdere shots (bijv. wide naar close-up) en de identiteit van personages, scènes en belichting consistent houden—voor een complete miniverhaallijn in één generatie.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performance- en motion re-enactment',
        preciseCameraControlDescription:
            'Met “video-to-video” kun je een echte performanceclip uploaden als referentie. Wan 2.6 kan het bewegingsbereik, gezichtsuitdrukkingen en zelfs het cameraritme nauwkeurig overdragen naar een nieuw gegenereerd virtueel personage (bijv. anime of 3D), waardoor “AI motion capture” mogelijk wordt.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Samenhangende 15-seconden videogenereer',
        enhancedVisualRealismDescription:
            'Genereer tot 15 seconden 1080p/24fps HD-video. Vergeleken met korte clips van traditionele modellen geeft Wan 2.6 meer tijd om complexe acties en omgevingsveranderingen te tonen, terwijl de visuele kwaliteit stabiel blijft.',

        // 如何使用部分
        howToUseTitle: 'Zo gebruik je Wan 2.6 op WeryAI',
        step1Title: 'Kies een model',
        step1Description: 'Selecteer het Wan 2.6-model in de AI Video-tool',
        step2Title: 'Voer je content in',
        step2Description:
            'Beschrijf de scène in het tekstvak, of upload een referentie-afbeelding/-video om “Image to Video” of “Performance & Motion Re-enactment” te gebruiken.',
        step3Title: 'Genereer de video',
        step3Description:
            'Stel parameters in (bijv. 16:9-beeldverhouding, 15 seconden), klik “Generate” en wacht even om je video met geluid te previewen en te downloaden.',

        // YouTube 视频部分
        youtubeTitle: 'YouTube-video\'s over het Wan 2.6-videomodel',

        // X Posts 部分
        xPostsTitle: 'Trending X-berichten over het Wan 2.6 AI-videomodel',

        // 探索其他模型部分
        exploreModelsTitle: 'Ontdek andere modellen',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Veelgestelde vragen',

        // CTA 部分
        ctaTitle: 'Klaar om te beginnen?',
        ctaDescription:
            'Probeer Wan 2.6 nu en zet je ideeën om in geweldige video\'s',
        ctaButton: 'Probeer Wan 2.6 nu',
        ctaDisclaimer: 'Geen creditcard nodig — meld je aan om te starten',

        // 视频播放相关
        videoNotSupported: 'Je browser ondersteunt geen video-afspeling',
        videoLoadingError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // 页面标题和描述
        pageTitle:
            'Generator Video Wan 2.6 - Platform Pembuatan Video AI Multimodal Generasi Baru',
        pageDescription:
            'Coba Wan 2.6, model generasi video AI multimodal flagship. Menghasilkan video sinematik 1080p dan terobosan Native Audio-Visual Sync—menghasilkan visual bersama efek suara dan suara yang cocok dalam sekali proses. Gratis dicoba di WeryAI.',
        pageKeywords:
            'Wan 2.6, generator video AI, model video AI multimodal, sinkron audio-visual native, 1080p sinematik, storyboarding cerdas, video AI gratis, WeryAI, pembuatan video',

        // 生成器部分
        generatorTitle: 'Model Generasi Video AI Multimodal Flagship Wan 2.6',
        short_title: 'Model Video AI Multimodal',
        generatorDescription:
            'WeryAI kini telah mengintegrasikan model Wan 2.6 secara mendalam, Wan 2.6 adalah model generasi video AI multimodal flagship terbaru dari tim Tongyi Wanxiang (Wanx) Alibaba Cloud. Sebagai peningkatan besar di seri Wan, model ini tidak hanya mendukung output sinematik 1080p, tetapi juga menghadirkan terobosan Native Audio-Visual Sync—menghasilkan visual bersama efek suara dan suara yang cocok dalam sekali proses. Dibangun untuk storytelling berdurasi panjang, Wan 2.6 memiliki storyboarding multi-shot cerdas yang memungkinkan hingga 15 detik kreasi multi-kamera yang koheren, membantu kreator dari skrip hingga final cut. Coba Wan 2.6 gratis di WeryAI dan masuk ke era baru “video dengan suara, dibuat oleh AI”.',
        generatorDescriptionHighlight1:
            'Wan 2.6 kini terintegrasi di generator video WeryAI untuk membuat video realistis',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'coba Wan 2.6 gratis',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // 核心功能部分
        coreFeaturesTitle: 'Fitur Utama Wan 2.6',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Generasi Sinkron Audio-Visual Native',
        nativeAudioIntegrationDescription:
            'Wan 2.6 menembus batas antara visual dan audio—saat menghasilkan video, ia dapat otomatis membuat audio yang tersinkron presisi (misalnya langkah kaki, hujan) bahkan lip-sync dialog karakter, sehingga menghasilkan aset audiovisual lengkap tanpa dubbing pasca-produksi.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Storytelling Multi-Shot Cerdas',
        enhancedDynamicEffectsDescription:
            'Dengan pemahaman semantik yang kuat, model dapat memecah prompt panjang yang kompleks menjadi beberapa shot (misalnya wide ke close-up) dan menjaga identitas karakter, adegan, serta pencahayaan tetap konsisten—menceritakan mini-story lengkap dalam satu generasi.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Re-enactment Performa & Gerak',
        preciseCameraControlDescription:
            'Dengan “video-to-video”, Anda dapat mengunggah klip performa nyata sebagai referensi. Wan 2.6 dapat mentransfer rentang gerak, ekspresi wajah, bahkan ritme kamera secara akurat ke karakter virtual baru (misalnya anime atau 3D), memungkinkan “AI motion capture”.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Generasi Video 15 Detik yang Koheren',
        enhancedVisualRealismDescription:
            'Hasilkan hingga 15 detik video HD 1080p/24fps. Dibanding klip pendek dari model tradisional, Wan 2.6 memberi lebih banyak waktu untuk menggambarkan aksi kompleks dan perubahan lingkungan sambil mempertahankan kualitas visual yang stabil.',

        // 如何使用部分
        howToUseTitle: 'Cara Menggunakan Wan 2.6 di WeryAI',
        step1Title: 'Pilih Model',
        step1Description: 'Pilih model Wan 2.6 di alat AI Video',
        step2Title: 'Masukkan Konten Anda',
        step2Description:
            'Jelaskan adegan yang diinginkan di kotak teks, atau unggah gambar/video referensi untuk mengaktifkan “Image to Video” atau “Performance & Motion Re-enactment”.',
        step3Title: 'Buat Video',
        step3Description:
            'Atur parameter (misalnya rasio 16:9, durasi 15 detik), klik “Generate”, lalu tunggu untuk pratinjau dan unduh video dengan suara.',

        // YouTube 视频部分
        youtubeTitle: 'Video YouTube tentang Model Video Wan 2.6',

        // X Posts 部分
        xPostsTitle: 'Posting X Tren tentang Model Video AI Wan 2.6',

        // 探索其他模型部分
        exploreModelsTitle: 'Jelajahi Model Lain',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Pertanyaan yang Sering Diajukan',

        // CTA 部分
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription:
            'Coba Wan 2.6 sekarang dan ubah ide Anda menjadi video yang menakjubkan',
        ctaButton: 'Coba Wan 2.6 Sekarang',
        ctaDisclaimer: 'Tidak perlu kartu kredit — daftar untuk mulai',

        // 视频播放相关
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadingError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        },
    tr: {
        // 页面标题和描述
        pageTitle:
            'Wan 2.6 Video Üretici - Yeni Nesil Çok Modlu AI Video Platformu',
        pageDescription:
            'Wan 2.6’yı deneyin: amiral gemisi çok modlu AI video üretim modeli. Sinematik 1080p video ve Native Audio-Visual Sync ile çığır açar—görüntüleri, uyumlu efektler ve seslerle tek seferde üretir. WeryAI’de ücretsiz deneyin.',
        pageKeywords:
            'Wan 2.6, AI video üretici, çok modlu AI video modeli, yerleşik ses-görüntü senkronu, sinematik 1080p, akıllı storyboarding, ücretsiz AI video, WeryAI, video üretimi',

        // 生成器部分
        generatorTitle: 'Wan 2.6 Amiral Gemisi Çok Modlu AI Video Modeli',
        short_title: 'Çok Modlu AI Video Modeli',
        generatorDescription:
            'WeryAI artık Wan 2.6 modelini derinlemesine entegre ediyor, Wan 2.6, Alibaba Cloud’un Tongyi Wanxiang (Wanx) ekibi tarafından yayımlanan en yeni amiral gemisi çok modlu AI video üretim modelidir. Wan serisindeki büyük bir yükseltme olarak yalnızca sinematik 1080p çıktı sunmakla kalmaz, Native Audio-Visual Sync ile de bir atılım sağlar—görüntüleri uyumlu efektler ve seslerle tek seferde üretir. Uzun form hikâye anlatımı için tasarlanan Wan 2.6, 15 saniyeye kadar tutarlı, çok kameralı üretime olanak tanıyan akıllı multi-shot storyboarding sunar; yaratıcıların senaryodan final kurgusuna geçmesine yardımcı olur. WeryAI’de Wan 2.6’yı ücretsiz deneyin ve “AI tarafından üretilen, sesli video” çağını başlatın.',
        generatorDescriptionHighlight1:
            'Wan 2.6 artık gerçekçi videolar üretmek için WeryAI video üreticisine entegre edildi',
        generatorDescriptionText2: '. Click here to',
        generatorDescriptionHighlight2: 'Wan 2.6’yı ücretsiz dene',
        generatorDescriptionEnd: '!',

        // 标签页
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // 核心功能部分
        coreFeaturesTitle: 'Wan 2.6 Temel Özellikler',

        // 原生音频集成功能
        nativeAudioIntegrationTitle: 'Yerleşik Ses-Görüntü Senkron Üretimi',
        nativeAudioIntegrationDescription:
            'Wan 2.6, görüntü ve ses arasındaki sınırı kaldırır—video üretirken otomatik olarak hassas senkronlu ses (ör. ayak sesi, yağmur) ve hatta karakter diyaloglarına lip-sync üretir; ek dublaj olmadan tam görsel-işitsel çıktı sağlar.',

        // 升级的动态效果功能
        enhancedDynamicEffectsTitle: 'Akıllı Multi-Shot Hikâye Anlatımı',
        enhancedDynamicEffectsDescription:
            'Güçlü anlamsal anlayışla model, karmaşık uzun promptları birden çok shot’a bölebilir (ör. genişten yakın plana) ve karakter kimliğini, sahneleri ve ışığı tutarlı biçimde koruyarak tek üretimde bütün bir mini hikâye anlatır.',

        // 精确的摄像机控制功能
        preciseCameraControlTitle: 'Performans ve Hareket Yeniden Canlandırma',
        preciseCameraControlDescription:
            '“Video-to-video” kullanarak gerçek bir performans klibini referans olarak yükleyebilirsiniz. Wan 2.6, hareket aralığını, yüz ifadelerini ve hatta kamera ritmini yeni üretilen sanal karaktere (ör. anime veya 3D) doğru şekilde aktararak “AI motion capture” sağlar.',

        // 增强的视觉真实感功能
        enhancedVisualRealismTitle: 'Tutarlı 15 Saniyelik Video Üretimi',
        enhancedVisualRealismDescription:
            '1080p/24fps HD videoda 15 saniyeye kadar üretim yapın. Geleneksel modellerdeki kısa kliplere kıyasla Wan 2.6, karmaşık eylemleri ve çevresel değişimleri daha uzun süre anlatırken görsel kaliteyi istikrarlı tutar.',

        // 如何使用部分
        howToUseTitle: 'WeryAI’de Wan 2.6 Nasıl Kullanılır',
        step1Title: 'Model Seçin',
        step1Description: 'AI Video aracında Wan 2.6 modelini seçin',
        step2Title: 'İçeriğinizi Girin',
        step2Description:
            'Metin kutusunda istediğiniz sahneyi anlatın veya “Image to Video” ya da “Performance & Motion Re-enactment” için referans görsel/video yükleyin.',
        step3Title: 'Videoyu Üretin',
        step3Description:
            'Parametreleri ayarlayın (ör. 16:9 en-boy oranı, 15 saniye süre), “Generate”e tıklayın, ardından sesli videoyu önizleyip indirmeniz için kısa süre bekleyin.',

        // YouTube 视频部分
        youtubeTitle: 'Wan 2.6 Video Modeli Hakkında YouTube Videoları',

        // X Posts 部分
        xPostsTitle: 'Wan 2.6 AI Video Modeli Hakkında Trend X Paylaşımları',

        // 探索其他模型部分
        exploreModelsTitle: 'Diğer Modelleri Keşfet',
        runwayTitle: 'Runway Gen-4.5',
        kling_2_6: 'Kling 2.6 Pro',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ 部分
        faqTitle: 'Sıkça Sorulan Sorular',

        // CTA 部分
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription:
            'Wan 2.6’yı şimdi deneyin ve fikirlerinizi harika videolara dönüştürün',
        ctaButton: 'Wan 2.6’yı şimdi dene',
        ctaDisclaimer: 'Kredi kartı gerekmez — başlamak için kaydolun',

        // 视频播放相关
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Video yüklenemedi',
        videoReload: 'Yeniden yükle',
    },
}
